module.exports = __webpack_public_path__ + "static/media/cp18.bb58c1dc.pdf";